export const EnumTipoDocumento = () => {
  return [
    { tipo: 'DIPLOMA_GRADUACAO', descricao: 'Diploma de Graduação' },
    { tipo: 'DIPLOMA_POS_GRADUACAO', descricao: 'Diploma de Pós Graduação' },
    { tipo: 'DIPLOMA_MESTRADO', descricao: 'Diploma de Mestrado' },
    { tipo: 'DIPLOMA_DOUTORADO', descricao: 'Diploma de Mestrado' },
    { tipo: 'CARTEIRA_CNH', descricao: 'CNH' },
    { tipo: 'CURRICULO', descricao: 'Currículo' },
    { tipo: 'CARTEIRA_CRM', descricao: 'Carteira CRM' },
  ];
};
